import {ApplicationStatusHeaderDTO} from './ApplicationStatusHeaderDTO';
import {ApplicationStatusResponseDTO} from './ApplicationStatusResponseDTO';

export class ApplicationStatusLookupDTO {
  schemaVersion: string;
  header: ApplicationStatusHeaderDTO;
  response: ApplicationStatusResponseDTO;
}
